/**
 * Model Store Module
 */
import { firebaseAction } from 'vuexfire'
import fb from '@/lib/fb'
import path from 'path'

// Types
import * as types from '../types'

// State
const state = {
	models: [],
	model: {},
}

// Actions
const actions = {
	loadModels: firebaseAction(({ rootState, commit, bindFirebaseRef }) => {
		commit(types.SET_LOADING, true)
		const modelsPath = rootState.user.refs.model
		const modelsRef = fb.database().ref(modelsPath)
		return new Promise((resolve, reject) => {
			bindFirebaseRef('models', modelsRef, { readyCallback: () => {
				commit(types.SET_LOADING, false)
				resolve()
			} })
		})
	}),
	unloadModels: firebaseAction(({ commit, unbindFirebaseRef }) => {
		try {
			unbindFirebaseRef('models')
		} catch (e) {}
	}),
	loadModel: firebaseAction(({ rootState, commit, bindFirebaseRef }, key) => {
		commit(types.SET_LOADING, true)
		const modelPath = path.join(rootState.user.refs.model, key)
		const modelRef = fb.database().ref(modelPath)
		return new Promise((resolve, reject) => {
			bindFirebaseRef('model', modelRef, { readyCallback: () => {
				commit(types.SET_LOADING, false)
				resolve()
			} })
		})
	}),
	unloadModel: firebaseAction(({ commit, unbindFirebaseRef }) => {
		commit(types.UNLOAD_MODEL)
		try {
			unbindFirebaseRef('model')
		} catch (e) {}
	}),
	loadModelsLocal: ({ rootState, commit }) => {
		const modelsPath = rootState.user.refs.model
		const modelsRef = fb.database().ref(modelsPath)
		return new Promise((resolve, reject) => {
			modelsRef.once('value').then(snap => {
				resolve(fb.prepOut(snap, true))
			})
		})
	},
	loadModelLocal: ({ rootState, commit }, key) => {
		const modelPath = path.join(rootState.user.refs.model, key)
		const modelRef = fb.database().ref(modelPath)
		return new Promise((resolve, reject) => {
			modelRef.once('value').then(snap => {
				resolve(fb.prepOut(snap))
			})
		})
	},
	addModel: ({ rootState, commit }, data) => {
		const key = data.key
		const model = fb.prepIn(data)
		const modelsPath = rootState.user.refs.model
		const modelsRef = fb.database().ref(modelsPath)

		return new Promise((resolve, reject) => {
			modelsRef.child(key).set(model)
				.then(res => resolve(key))
				.catch(err => reject(err))
		})
	},
	removeModel: ({ commit }, data) => {
		const ref = fb.ref(data)

		return fb.database().ref(ref).remove()
	},
	updateModel: ({ commit }, data) => {
		const key = fb.key(data)
		const model = fb.prepIn(data)
		const ref = fb.ref(data)
		const modelRef = fb.database().ref(ref)

		return new Promise((resolve, reject) => {
			modelRef.update(model).then(() => {
				resolve(key)
			})
		})
	},
}

// Mutations
const mutations = {
	[types.UNLOAD_MODEL](state) {
		state.model = {}
	},
	[types.UNLOAD_MODELS](state) {
		state.models = []
	},
	[types.SET_LOADING](state, loading) {
		state.loading = loading
	},
}

// Getters
const getters = {
	models: state => state.models,
	model: state => {
		// Prioritize Properties
		let priority = 0
		for (const prop in state.model.properties) {
			if (Object.prototype.hasOwnProperty.call(state.model.properties, prop)) {
				state.model.properties[prop]['.priority'] = priority
				priority++
			}
		}

		return state.model
	},
}

export default {
	state,
	mutations,
	getters,
	actions,
}



// WEBPACK FOOTER //
// ./src/lib/store/modules/model.js